import * as mime from 'mime';

export const checkAcceptedExtensions = (acceptedExtensions) => {
  const filePatternObj = {};

  acceptedExtensions.forEach((extension) => {
    const mimeType = mime.getType(extension);
    if (mimeType) {
      if (Object.prototype.hasOwnProperty.call(filePatternObj, mimeType)) {
        const extensionsArray = filePatternObj[mimeType];
        extensionsArray.push(extension);
        filePatternObj[mimeType] = extensionsArray;
      } else {
        filePatternObj[mimeType] = [extension];
      }
    } else {
      switch (extension) {
        case '.264':
          if (Object.prototype.hasOwnProperty.call(filePatternObj, 'video/x-mpeg-avc')) {
            const extensionsArray = filePatternObj['video/x-mpeg-avc'];
            extensionsArray.push(extension);
            filePatternObj['video/x-mpeg-avc'] = extensionsArray;
          } else {
            filePatternObj['video/x-mpeg-avc'] = [extension];
          }
          break;
        case '.ape':
          if (Object.prototype.hasOwnProperty.call(filePatternObj, 'audio/x-monkeys-audio')) {
            const extensionsArray = filePatternObj['audio/x-monkeys-audio'];
            extensionsArray.push(extension);
            filePatternObj['audio/x-monkeys-audio'] = extensionsArray;
          } else {
            filePatternObj['audio/x-monkeys-audio'] = [extension];
          }
          break;
        case '.cda':
          if (Object.prototype.hasOwnProperty.call(filePatternObj, 'application/x-cda')) {
            const extensionsArray = filePatternObj['application/x-cda'];
            extensionsArray.push(extension);
            filePatternObj['application/x-cda'] = extensionsArray;
          } else {
            filePatternObj['application/x-cda'] = [extension];
          }
          break;
        case '.dav':
          if (Object.prototype.hasOwnProperty.call(filePatternObj, 'application/octet-stream')) {
            const extensionsArray = filePatternObj['application/octet-stream'];
            extensionsArray.push(extension);
            filePatternObj['application/octet-stream'] = extensionsArray;
          } else {
            filePatternObj['application/octet-stream'] = [extension];
          }
          break;
        case '.mht':
          if (Object.prototype.hasOwnProperty.call(filePatternObj, 'application/octet-stream')) {
            const extensionsArray = filePatternObj['application/octet-stream'];
            extensionsArray.push(extension);
            filePatternObj['application/octet-stream'] = extensionsArray;
          } else {
            filePatternObj['application/octet-stream'] = [extension];
          }
          break;
        case '.mnm4':
          if (Object.prototype.hasOwnProperty.call(filePatternObj, 'video/mnm4')) {
            const extensionsArray = filePatternObj['video/mnm4'];
            extensionsArray.push(extension);
            filePatternObj['video/mnm4'] = extensionsArray;
          } else {
            filePatternObj['video/mnm4'] = [extension];
          }
          break;
        case '.nvf':
          if (Object.prototype.hasOwnProperty.call(filePatternObj, 'application/octet-stream')) {
            const extensionsArray = filePatternObj['application/octet-stream'];
            extensionsArray.push(extension);
            filePatternObj['application/octet-stream'] = extensionsArray;
          } else {
            filePatternObj['application/octet-stream'] = [extension];
          }
          break;
        case '.wv':
          if (Object.prototype.hasOwnProperty.call(filePatternObj, 'audio/x-wv')) {
            const extensionsArray = filePatternObj['audio/x-wv'];
            extensionsArray.push(extension);
            filePatternObj['audio/x-wv'] = extensionsArray;
          } else {
            filePatternObj['audio/x-wv'] = [extension];
          }
          break;
        default: // no default really required here
          break;
      }
    }
  });

  return filePatternObj;
};
